<template>
    <TemplatesNeighborhoodsSingle />
</template>
